import { useEffect, useRef } from 'react'

/**
 * Hook to handle Escape key press
 *
 * @param {Function} onEscape - Callback when Escape is pressed
 * @param {boolean} enabled - Whether listener is active (default: true)
 */
export function useEscapeKey (onEscape, enabled = true) {
  const callbackRef = useRef(onEscape)

  useEffect(() => {
    callbackRef.current = onEscape
  })

  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        callbackRef.current()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [enabled])
}
